<template>
     <section class="bg-dark text-white space-xlg jarallax h-100" data-jarallax data-speed="0.2">
        <img alt="Image" :src="images?.[img]?.['path']" class="bg-image opacity-40 jarallax-img" />
        <!-- [
            0: {},
            1: {
                path"
                filename
            },
            2: {}
        ] -->
        <div class="container">
            <div class="row text-center justify-content-center section-intro mb-3">
                <div class="col-12 col-md-10 col-lg-8">
                    <h1 class="display-5 m-0">{{appname}}</h1>
                    <span class="lead"></span>
                </div>
                <!--end of col-->
            </div> 

            <!--end of row-->
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <div class="card card-sm">
                        <div class="card-body row no-gutters align-items-center">
                        <div class="col-auto">
                            <i class="icon-magnifying-glass h4 text-body"></i>
                        </div>
                        <!--end of col-->
                        <div class="col">
                            <input class="form-control form-control-lg form-control-borderless" type="search" placeholder="Search topics or keywords" v-model="search_string" @keypress.enter="search" />
                        </div>
                        <!--end of col-->
                        <div class="col-auto">
                            <jl-button :class="'btn btn-lg btn-success'" :eventClick="search">Search</jl-button>
                        </div>
                        <!--end of col-->
                        </div>
                    </div>
                </div>
                <!--end of col-->
            </div>
            <!--end of row-->

            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8   card-body bg-transparent p-2">
                    <span class="lead  fw-500 m-0 text-white">Recent Uploads</span>

                    <ul class="list-group" > 
                        <li class="list-group-item bg-transparent text-white fw-500 p-2 b-0" v-for="(recent, i) in recent_uploads" :key="i">
                            <span class="line-clamp">{{recent.particular}}</span>
                            <router-link :to="'/detail?common_number='+recent.common_number">
                            <small class="d-block fs-14">FileName: {{recent.filename}}</small>
                            </router-link>
                            <!-- <a :href="'/detail?common_number='+recent.common_number">
                               <small class="d-block fs-14">FileName: {{recent.filename}}</small>
                            </a> -->
                            <small class="d-block fs-14">Date: {{recent.date_uploaded}}</small>
                        </li>
                    </ul>
                </div>

            </div>
        
        </div>
        <!--end of container-->
    </section>
    <!--end of section-->
</template>

<script>
export default {
    data() {
        return {
            search_string: '',
            recent_uploads: [],
            images: [],
            img: {path:'',filename:''},
            page: 1
        }
    },
    methods: {
        async loadRecentUploads() {
            await this.$axios.get('/recent')
            .then(response => { 
                let data = response.data;
                this.recent_uploads = data;  

                // console.log(this.recent_uploads)
            })
            .catch(error => { 
                this.$jlalert.show(error);
            });
        },
        search() {
            //native js
            //window.location.href = "/result";

            //php
            //redirect('/result'); //CODEIGNITER
            //header('location: /result'); //NATIVE PHP

            //vue style
            this.$router.push(`/result?query=${this.search_string}&page=${this.page}`)
        },
        importAll(r) {
            r.keys().forEach(key => (this.images.push({ path: r(key), filename: key })));
        },
        getimage(){
            for(var i = 0; i < this.images.length; i++) {
                let check = this.images[i].filename; //11novemer
                var Today = new Date(); 
                var curMonth =  Today.getMonth()+1;
                let search = curMonth
                
                if (check.search(search) !== -1){
                    this.img=i; 
                }
            }

            // var Today = new Date(); 
            // var curMonth =  Today.getMonth()+1;
            // let search = curMonth;
            // const images = this.images; // [ .., .. ,, ..]
            // const filter =  images.find(el => {
            //                     var filename = el.filename;
            //                     return (filename.search(search) !== -1)
            //                 })
            // console.log(filter);
        }
    },
    mounted() {
        this.loadRecentUploads(); 
        var images = this.importAll(require.context('../../assets/background/', true, /\.jpeg$/));
        console.log(images);
        this.getimage();
    }
}
</script>

<style scoped>
.line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
}
a{
    color: white;
}
</style>